import { InternetUsage, InternetUsageData } from '@/types/internet/InternetType'
import { Translator } from '../../types/ApiResponseTypes'
import { InternetUsageResponseData, isInternetUsageResponse } from '@/types/internet/InternetResponseType'

class InternetUsageResponseTranslator implements Translator<InternetUsage> {
  convert(response: any): InternetUsage {
    const internetUsage: InternetUsage = { dateFrom: undefined, dateTo: undefined, period: 'day', usage: [] }

    if (isInternetUsageResponse(response)) {
      internetUsage.dateFrom =
        'dateFrom' in response && response.dateFrom != undefined ? new Date(Date.parse(response.dateFrom)) : new Date()
      internetUsage.dateTo =
        'dateFrom' in response && response.dateTo != undefined ? new Date(Date.parse(response.dateTo)) : new Date()
      internetUsage.period = 'period' in response && response.period != undefined ? response.period : 'day'

      if (Array.isArray(response.usage)) {
        const usagedata: InternetUsageData[] = []
        response.usage.forEach((usage: InternetUsageResponseData) => {
          usagedata.push(this.convertToInternetUsageModel(usage))
        })
        internetUsage.usage = usagedata
      }
    }
    return internetUsage
  }

  convertToInternetUsageModel(usage: InternetUsageResponseData): InternetUsageData {
    return {
      date: usage.date,
      up: usage.up,
      down: usage.down,
    }
  }
}
export default new InternetUsageResponseTranslator()
